import React, { useEffect, useState } from 'react';
import axiosInstance from '../api/api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/Notification.css';

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNotifications = async () => {
    try {
      const res = await axiosInstance.get('/notifications');
      setNotifications(res.data);
    } catch (err) {
      toast.error('Failed to load notifications');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axiosInstance.put(`/notifications/${id}/read`);
      fetchNotifications();
    } catch (err) {
      toast.error('Failed to mark as read');
    }
  };

  const markAllAsRead = async () => {
    try {
      await axiosInstance.put('/notifications/mark-all-read');
      fetchNotifications();
      toast.success('All notifications marked as read');
    } catch (err) {
      toast.error('Failed to mark all as read');
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  return (
    <div className="notification-page">
      <ToastContainer />
      <div className="notification-header">
        <h2>📬 Your Notifications</h2>
        <button onClick={markAllAsRead} className="mark-all-btn">
          Mark All as Read
        </button>
      </div>

      {loading ? (
        <p className="loading">Loading notifications...</p>
      ) : notifications.length === 0 ? (
        <p className="no-notifications">You're all caught up 🎉</p>
      ) : (
        <div className="notification-list">
          {notifications.map((n) => (
            <div
              key={n.id}
              className={`notification-card ${n.read ? 'read' : 'unread'}`}
            >
              <div className="notification-info">
                <span className="notification-type">{n.type.replace(/_/g, ' ')}</span>
                <p className="notification-message">{n.message}</p>
              </div>
              <div className="notification-footer">
                <span className="timestamp">
                  {new Date(n.timestamp).toLocaleString()}
                </span>
                {!n.read && (
                  <button
                    onClick={() => markAsRead(n.id)}
                    className="read-btn"
                  >
                    Mark as Read
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Notification;
